import React, {Component} from 'react';
import {isLogin, route, routes} from "../../vars/rd";
import Business from "../components/popup/business";


class AuthBusiness extends Component {
    constructor(props) {
        super(props);
        if(!isLogin()) route(routes.login);
    }


    render() {
        return (
            <div className="channel">
                <h2><span>내 업종</span>을 선택해 주시면<br/>업종별 어울리는 채널을 추천해 드릴게요.</h2>
                <h4>이후 마이페이지에서 수정 가능합니다.</h4>
                <Business is_popup={false} />
            </div>
        );
    }
}

export default AuthBusiness;


// WEBPACK FOOTER //
// ./src/pages/auth/business.jsx